module.exports = __webpack_public_path__ + "static/media/azim.7389252f.jpg";